/**
 * ssom.js
 */
 export const SSOM = (function () {

    var init =  function () {
        
      let path = window.location.pathname;
      // if the route is for create an organisation check the route to add
      // a bold class to the tabs at the top of the form
      if (path.indexOf('create-organisation') >= 0) {
        path = path.split('/');
        let tab = path[path.length -1];
        document.querySelector(`[data-step="${tab}"]`).classList.add('font-weight-bold');
      }

        $('.subscriber-dropdown').on('click', (e) => {
            $('.susbscriber-list').removeClass('d-none');
        });

        $('.send-invite').on('click', (e) => {
            e.preventDefault();
            $('#subscribers-invites').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.myds-suspend').on('click', (e) => {
            e.preventDefault();
            $('#suspend').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        $('.myds-open-roles').on('click', (e) => {
            $('.myds-macm-default-roles').toggleClass('d-none');
        });

        $('.myds-open-role-form').on('click', (e) => {
            $('#create-role').toggleClass('d-none');
        });

        $('.myds-invite-member').on('click', (e) => {
            e.preventDefault();
            $('#members-invites').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
        });

        // Populate Member Roles 
        $('#myds-ssom-save-member-roles').on('click', (e) => {
          editMemberRoles(e);
        });

        /**
         * Event Handler which listens for mouse click event - attatched to the
         * Add Member button on /organisations/{orgid}/members page
         * @type {HTMLElement} - the target of the event
         * @listens document#click - the namespace and name of the event
         * @param {Event} e
         */
        $('#add_mydexID').on('click', function(e) {
          e.preventDefault();
          //checks if mydexid already exists
          var mydexid = $("input[name=mydexid]").val();
          var roleName = $('#ssom-roles').find(":selected").text();
          var organisation_id = $(this).attr('data-id');
          var roleID = $('#ssom-roles').find(":selected").val();

          if (roleName == 'Select role') {
            return Util.toggleAlert('#myds-ssom-members', 'Please select a role.', 'alert-warning');
          }

          if (mydexid !== '' && roleName !== 'Select role') {
            
            checkMydexidExists(mydexid).done(function (response) {
              if (response.success === 0) {
                return Util.toggleAlert('#myds-ssom-members', response.message, 'alert-warning');
              } else {
                addMydexidAndRole(mydexid, roleID, organisation_id);
              }
            });
            
          } else {
            return Util.toggleAlert('#myds-ssom-members', 'Please write a mydexid.', 'alert-warning');
          }
          
        });
        /**
         * Event Handler which listens for mouse click event - attatched to the
         * Next button in the organisation creation form steps
         * @type {HTMLElement} - the target of the event
         * @listens document#click - the namespace and name of the event
         * @param {Event} e
         */
        $('.next').on('click', function(e) {
          e.preventDefault();
          // see if this is only needed for first step then change it
          let formData = $('form[name="create-organisation"]').serializeArray();

          if (!validateFieldsNotEmpty(formData)) {
            return Util.toggleAlert('#organisation-form-alert', 'Please fill in all the required fields', 'alert-primary', 5000);
          }

          let url = '/organisations/create-organisation';
          let id = $(this).attr('data-id');
          let nextUrl = $(this).attr('href');
          let formID = $(this).attr('data-form');

          if (nextUrl.indexOf('contacts') >= 0) {
            url += `/${id}/office?organisation_id=${formID}`;
          } else if (nextUrl.indexOf('features') >= 0) {
            url += `/${id}/contacts?organisation_id=${formID}`;
          }

          saveOrganisationData(url, formData, nextUrl);
        });
        /**
         * Event listener that copies the main address values in the administration input fields
         */
        $('.address-copy').on('click', function(e) {
          let officeAddress = $('.office :input').serializeArray();
          
          officeAddress.forEach((element) => {
            let name = element.name;
            let indexName = name.substring(
              name.indexOf("][") + 2,
              name.lastIndexOf("]")
            );
            $(`#${indexName}`).val(element.value);
          });
        });
        /**
         * Event listener to add a new set of contact fields in the organisation contacts template
         * depending on the type
         */
        $('.contact').on('click', function(e) {
          let type = $(e.target).attr('data-type');
          let title = e.target.innerText;
          let content = $('#additional-contact-details').html();
          let extraContactDiv = $('.additional-contacts');
          let newContactDiv = $('<div class="new-contact"></div>');

          content = content.replace(/\[temp\]/g, '[' + type + ']');
          newContactDiv.html(content);
          newContactDiv.prepend(`<h5>${title}</h5>`)
          extraContactDiv.prepend(newContactDiv);

        });
        /**
         * Event listener to remove contact fields from UI
         */
        $('.additional-contacts').on('click', '.myds-delete-org-contact', function(e) {
          e.preventDefault();
          
          $(this).parent().remove();
        });

      // Used to send invites to members to join an organisation
      $('#ssom-send-organisation-invites').on('click', function (e) {

        e.preventDefault();
        invites(this, 'myds-invites-roles-alert-modal', true);
      });

      // Used to send invites to members to join an organisation as admin
      $('#send-admin-invites').on('click', function (e) {
        e.preventDefault();

        invites(this, 'myds-invites-org-alert-modal', false);
      });
    }

    function editMemberRoles(e) {
      // Get all checked toggles
      let checkedRoles = [];
      checkedRoles  = $('.myds-role:checked').map(function() {
        return this.value;
      }).get();
      let mydexid = $('#myds-ssom-save-member-roles').attr('data-mydexid');

      let promises = [];

      promises.push($.ajax({
        url: `members/${mydexid}/roles`,
        type: 'PUT',
        data: {
            roles: checkedRoles
        },
        headers: {
          'x-csrf-token': Util.getCSRF() 
        }
      }));

      // Get the name from the UI
      let name = $('#myds-member-name').val();

      if (name) {
        promises.push($.ajax({
          url: `members/${mydexid}`,
          type: 'PUT',
          data: {
              name: name
          },
          headers: {
            'x-csrf-token': Util.getCSRF() 
          }
        }));
      }

      // Show an alert on success and fail
      Promise.all(promises).then((values) => {
        Util.toggleAlert(
          '#myds-alert-modal', 
          "Success, member roles updated", 
          'alert-success',
          -1
        );
      // Refresh the bootstrap table
        $('#ssom-members-roles-table').bootstrapTable('refreshOptions', {
          url: `members/roles`,
          method : "GET"
        });
      })
      .catch((error) => {
        Util.toggleAlert(
          '#myds-alert-modal', 
          "Sorry, there was an error updating the member roles.", 
          'alert-danger', 5000
        );
      });


    }

    let tables = {

      populateMemberServiceRolesTable: function(data) {
        // Poppulate the MydexID on the save changes button for later
        let mydexid = data.mydexid;
        let organisation_id = data.organisation_id;
        let service_id = data.service_id;
        let feature_group_machine_name = data.feature_group_machine_name;
        let url =  `/organisations/${organisation_id}/${feature_group_machine_name}/${service_id}/members/${mydexid}/roles`;
        SSOM.tables.populateRolesTable(mydexid, url);
      },
      populateMemberRolesTable: function(mydexID) {
        // Poppulate the MydexID on the save changes button for later
        let url =  `members/${mydexID}/roles`;
        SSOM.tables.populateRolesTable(mydexID, url);
      },
      populateRolesTable: function(mydexid,url) {
        // Poppulate the MydexID on the save changes button for later
        $(`#myds-ssom-save-member-roles`).attr('data-mydexid',mydexid);
        
        let promise = $.ajax({
          url: url,
          type: 'get'
        });
        
        promise.done(function (response) {
          if ($(`#myds-member-name`).length >= 1) {
            // Populate the name
            $(`#myds-member-name`).val();
            $(`#myds-member-name`).val(response.member.details.name);
          }
            
          // Populate the toggles
          $(`.myds-role`).prop("checked", false);
          response.member.roles.forEach(role => {
            $(`#myds-role-${role.id}`).prop("checked", true);
          });
  
          if(response.member.is_session_member)
          {
            // Disable the checkbox sliders and show the "you" indicator
            $(`.slider`).click(function () {
              $('#myds-ssom-role-poppover').popover('toggle');
            });
            $(`.myds-role`).prop( "disabled", true );
            $(`#myds-ssom-you-indicator`).removeClass('d-none');
          } else {
            $(`.myds-role`).prop( "disabled", false );
            $(`#myds-ssom-you-indicator`).addClass('d-none');
            $(".slider").unbind();
          } 
        }) 
      }
    }

    let formatters = {
      serviceRoleEditFormatter : function(value,row,index,field){
        return `<button data-mydexid="${row['mydexid']}" data-organisation_id="${row['organisation_id']}"  data-service_id="${row['service_id']}" data-feature_group_machine_name="${row['feature_group_machine_name']}" class="text-primary btn m-0 p-0 ml-2 mr-3 myds-edit-member-service"> <i class='fas fa-edit'></i> </button>`;
      },
      roleEditFormatter : function(value,row,index,field){
        return `<button data-mydexid="${row['mydexid']}" data-organisation_id="${row['organisation_id']}" data-feature_group_machine_name="${row['feature_group_machine_name']}" class="text-primary btn m-0 p-0 ml-2 mr-3 myds-edit-member"> <i class='fas fa-edit'></i> </button>`;
      },
      blankNameFormatter : function(value,row,index,field){
        if(!value){
          return `<em>Click Edit to Add</em>`;
        }
        return value
      }
    }

    let operateEvents = {
      'click .myds-edit-member': function (e, value, row, index) {
        $('#myds-edit-member-modal').modal('show');
        SSOM.tables.populateMemberRolesTable(row.mydexid);
      },
      'click .myds-edit-member-service': function (e, value, row, index) {
        $('#myds-edit-member-modal').modal('show');
        SSOM.tables.populateMemberServiceRolesTable(row);
      }
    }
    
    /*
    * checks with the api-idp that mydex is a registered mydexid (it exist)
    * @param {string} mydexid
    */
    let checkMydexidExists = function(mydexid) {
  
      let csrf = Util.getCSRF();
      
      return $.ajax({
        url: '/organisations/validate-mydexid',
        type: 'post',
        data: {
          'mydexid' : mydexid
        },
        headers: {
          'x-csrf-token': csrf
        }
      }).fail(function(response) {
        return Util.toggleAlert('#myds-ssom-members', 'Unable to validate mydexid', 'alert-warning');
      });
    }

    /*
    * adds mydex id with a role as a member
    * @param {string} mydexid mydexid of the member to add
    * @param {string} roleID id of the role
    * @param {string} organisation_id id of the organisation
    * @return {array} sucess true or false
    */
    let addMydexidAndRole = function(mydexid, roleID, organisation_id) {
      let csrf = Util.getCSRF();
      
      $.ajax({
        url: `/organisations/${organisation_id}/add-member`,
        type: 'post',
        data: {
          'mydexid' : mydexid,
          'role-id': roleID
        },
        headers: {
          'x-csrf-token': csrf
        }
      }).done(function (response) {
        
        if (response.success === 0) {
          return Util.toggleAlert('#myds-ssom-members', response.message, 'alert-warning');
        } else {
          $('#ssom-members-roles-table').bootstrapTable('refreshOptions', {
            url: `members/roles`,
            method : "GET"
          });
          return Util.toggleAlert('#myds-ssom-members', 'Mydexid added succesfully.', 'alert-primary');
        }
      }).fail(function(err) {
        return Util.toggleAlert('#myds-ssom-members', "Unable to add member.", 'alert-warning');
      });
    }
    /**
     * Function that validates that values passed are not empty
     * @param {array} fields fields with values to validate
     */
    let validateFieldsNotEmpty = function(fields) {
      return !fields.some(function(field) {
          return !field.value && field.name.indexOf('number') < 0
      });
    }
    /**
     * Ajax Request function that sends data via post request to save organisation related data
     * @param {string} url endpoint to post the request
     * @param {array} data array of objects containing the data to send in the request
     * @param {string} nextUrl endpoint to redirect if request is successful
     */
    let saveOrganisationData = function(url, data, nextUrl) {
      let csrf = Util.getCSRF();
      
      $.ajax({
        headers: {
          'x-csrf-token': csrf
        },
        url: url,
        type: 'POST',
        data: data
      }).done(function (response) {
        window.location.href = nextUrl + '?new-organisation=' + response.organisation_id;
        
      }).fail(function(error) {
        let err = error.responseJSON.exception ? error.responseJSON.exception[0].message : error.responseJSON.message;
        return Util.toggleAlert('#organisation-form-alert', err, 'alert-primary', 5000);
      });  
    }
    /**
     * Gets the type of the invite and organisation id and calls the sendOrganisationMemberInvites function
     * @param {element} element element
     * @param {string} modalID name of the alert used in the modal
     * @param {boolean} check true/false used to check if roles are selected or not
     */
    let invites = function(element, modalID, check) {
      let inviteType = $(element).attr('data-type');

      if (inviteType == 'inclued') {
        return;
      }
      let senderOrgID = $(element).attr('data-id');
      
      try {
        sendOrganisationMemberInvites(inviteType, senderOrgID, modalID, check);
      } catch (error) {
        Util.toggleAlert(`#${modalID}`, error, 'alert-danger', -1);
      }
    }

    /**
    * Organises the data sent in the payload and sends the data in an ajax request to send an invite
    * @param {string} inviteType type of the invite being sent
    * @param {string} organisationId id of the organisation sending the invite
    * @param {string} modal name of the alert used in the modal
    * @param {boolean} rolesCheck true/false used to check if roles are selected or not
    */
    // TODO: once the code in Inclued is updated this can be move to the invites.js component
    let sendOrganisationMemberInvites = function(inviteType, organisationId, modal, rolesCheck) {

        let payload = {};
  
        // Get the email list and get they are valid
        let email_list = document.getElementById('email_invite_list').value;
        email_list = Invites.splitInputLists(email_list); 
        // Get the SMS list and get they are valid
        let sms_list = document.getElementById('sms_invite_list').value;
        sms_list =  Invites.splitInputLists(sms_list); 
        // Validate contact list is not empty
        if (!Invites.validation.isContactListEmpty(email_list) && !Invites.validation.isContactListEmpty(sms_list)) {
          throw Error("There must be at least 1 valid Email Address or SMS Number.")
        }
        // Validate emails format is correct
        if(!Invites.validation.checkEmails(email_list)){
          throw new Error("Emails must be correct format.");
        }
        // Validate sms format is correct
        if(!Invites.validation.checkSMS(sms_list)){
          throw new Error("SMS numbers must be in correct format.");
        }
        /**
         * For each contact format a payload for each email
         */
        email_list = Invites.mapPayload(email_list, "email", '');
        sms_list = Invites.mapPayload(sms_list, "sms", '');

        // Filter out any duplicates 
        email_list = Invites.filterDuplicates(email_list);
        sms_list = Invites.filterDuplicates(sms_list);

        payload.contact_list = email_list.concat(sms_list);

        let role_ids = [];

        if (rolesCheck) {
          // Get the elements roles which have been selected
          let checked_roles = document.querySelectorAll('input[name=roles-checkbox]:checked');
          // Check there is a role
          if (checked_roles.length == 0) {
            throw Error("A role must be allocated to a member.");
          }

          checked_roles.forEach(element => {
            return role_ids.push(element.value);
          });

          payload['role_ids'] = role_ids;
          payload.subscriber_id = organisationId;

        } else {
          payload['role_ids'] = ["2"];
          payload.subscriber_id = $('#org-select option:selected').val();
        }
        
        payload.organisation_id = organisationId;
        payload.type = inviteType;
        /**
         * Send the invites and get the promise
         */
        let promise = Invites.http.send(
          `/organisations/${organisationId}/send-${inviteType}-invites`,
          payload
        );

        // Add the MACM Content
        promise.then(function (response) {
            // Clear UI
            document.getElementById('email_invite_list').value = "";
            document.getElementById('sms_invite_list').value = "";
        });


        promise.then(function(){
          Util.toggleAlert(
            `#${modal}`, 
            "Success! Invites Sent!", 
            'alert-success',
            -1)
        });
        
        promise.fail(function (response) {
          let error = response['error'] ? response['error'] : 'Sorry, an error occurred. Please try again.';
          Util.toggleAlert(`#${modal}`, error, 'alert-danger', -1);
        });
  
    };
    

    return {
      init: init,
      formatters: formatters,
      editMemberRoles:editMemberRoles,
      tables : tables,
      operateEvents: operateEvents
    }
  
}());
  